import { ArrowDownIcon, ArrowUpIcon } from "lucide-react";

import { Row } from "@/components/Row";
import { TableHead } from "@/components/ui/table";

import { cn } from "@/lib/utils";
import { SortOrder } from "@/types";

interface ColumnSortState<K extends string> {
  key: K;
  direction: SortOrder;
}

export const SortableHeader = <K extends string>({
  className,
  label,
  onSort,
  sort,
  sortKey,
}: {
  className?: string;
  label: string;
  onSort: (key: K) => void;
  sort: ColumnSortState<K> | null;
  sortKey: K;
}) => {
  const isActive = sort?.key === sortKey;

  const renderIcon = () => {
    if (!isActive) return null;
    if (sort.direction === SortOrder.Asc) {
      return <ArrowUpIcon className="h-3.5 w-3.5 shrink-0 text-slate-500" />;
    }
    return <ArrowDownIcon className="h-3.5 w-3.5 shrink-0 text-slate-500" />;
  };

  /* Render */
  const render = () => (
    <TableHead
      className={cn("cursor-pointer select-none hover:bg-slate-100", className)}
      onClick={() => {
        onSort(sortKey);
      }}
    >
      <Row className={cn("min-w-0 items-center gap-1.5")}>
        {/* min-w-0 + truncate so a long label ellipsizes inside its fixed-width column. */}
        <span className="min-w-0 truncate">{label}</span>
        {renderIcon()}
      </Row>
    </TableHead>
  );

  return render();
};
